// Tsjechische taal — woordenlijst + quiz-modus.

import { setTitle } from '../main.js'
import { icon } from '../icons.js'
import { esc } from './_shared.js'

function shuffle(arr) {
  const a = [...arr]
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]]
  }
  return a
}

export function renderPhrases(root, ctx) {
  setTitle('')
  const phrases = ctx.data.phrases ?? []
  if (!phrases.length) {
    root.innerHTML = `<div class="page"><h1 class="title">Tsjechische taal</h1><p class="empty">Nog geen zinnen.</p></div>`
    return
  }

  let quizMode = false

  root.innerHTML = `
    <div class="page">
      <div class="crumbs"><a href="#/home">‹ Home</a></div>
      <h1 class="title">Tsjechische taal</h1>
      <p class="subtitle">Een handvol zinnen voor in het café, bij de balie en bij de buschauffeur.</p>
      <div class="phrase-tabs">
        <button class="chip active" id="tab-list">${icon('book-open')} Woordenlijst</button>
        <button class="chip" id="tab-quiz">${icon('sparkles')} Test me!</button>
      </div>
      <div id="phrase-list-view">
        <input type="search" id="phrase-search" placeholder="Zoek een zin…" class="search-input" autocomplete="off" />
        <div id="phrase-list"></div>
      </div>
      <div id="phrase-quiz-view" hidden></div>
    </div>
  `

  // --- List mode ---
  function renderList(filter) {
    const q = (filter || '').toLowerCase()
    const filtered = q
      ? phrases.filter(p =>
          (p.cz || '').toLowerCase().includes(q) ||
          (p.nl || '').toLowerCase().includes(q) ||
          (p.pron || '').toLowerCase().includes(q))
      : phrases

    const byCategory = new Map()
    for (const p of filtered) {
      const key = p.category || 'Algemeen'
      if (!byCategory.has(key)) byCategory.set(key, [])
      byCategory.get(key).push(p)
    }

    const blocks = []
    for (const [cat, list] of byCategory) {
      blocks.push(`<h2 class="section-heading">${esc(cat)}</h2>`)
      for (const p of list) {
        blocks.push(`
          <div class="phrase-card">
            <div class="phrase-cz">${esc(p.cz)}</div>
            <div class="phrase-nl">${esc(p.nl)}</div>
            ${p.pron ? `<div class="phrase-pron">/${esc(p.pron)}/</div>` : ''}
            ${p.note ? `<div class="e-meta" style="margin-top:6px">${esc(p.note)}</div>` : ''}
          </div>`)
      }
    }

    if (!filtered.length) blocks.push('<p class="empty">Geen resultaten.</p>')
    return blocks.join('')
  }

  root.querySelector('#phrase-list').innerHTML = renderList('')
  root.querySelector('#phrase-search').addEventListener('input', (e) => {
    root.querySelector('#phrase-list').innerHTML = renderList(e.target.value)
  })

  // --- Quiz mode ---
  function pickQuestion() {
    const correct = phrases[Math.floor(Math.random() * phrases.length)]
    const others = shuffle(phrases.filter(p => p.nl !== correct.nl)).slice(0, 3)
    const options = shuffle([correct, ...others])
    return { correct, options }
  }

  function renderQuiz() {
    const quizView = root.querySelector('#phrase-quiz-view')
    const q = pickQuestion()

    quizView.innerHTML = `
      <div class="quiz-card phrase-quiz-card">
        <div class="quiz-prompt">
          <div class="pin-cat">Wat betekent…</div>
          <div class="phrase-cz" style="font-size:1.3rem;margin:10px 0">${esc(q.correct.cz)}</div>
          ${q.correct.pron ? `<div class="phrase-pron" style="margin-bottom:12px">/${esc(q.correct.pron)}/</div>` : ''}
        </div>
        <div class="quiz-options">
          ${q.options.map(o => `
            <button class="quiz-option" data-answer="${esc(o.nl)}">${esc(o.nl)}</button>
          `).join('')}
        </div>
        <div class="quiz-feedback" hidden></div>
      </div>
    `

    quizView.querySelectorAll('.quiz-option').forEach(btn => {
      btn.addEventListener('click', () => {
        const isCorrect = btn.dataset.answer === q.correct.nl
        const feedback = quizView.querySelector('.quiz-feedback')

        quizView.querySelectorAll('.quiz-option').forEach(b => {
          b.disabled = true
          if (b.dataset.answer === q.correct.nl) b.classList.add('correct')
          else if (b === btn && !isCorrect) b.classList.add('wrong')
        })

        feedback.hidden = false
        feedback.innerHTML = isCorrect
          ? `<span class="quiz-correct">${icon('check')} Goed!</span>`
          : `<span class="quiz-wrong">${icon('x')} Het juiste antwoord was: <strong>${esc(q.correct.nl)}</strong></span>`

        feedback.insertAdjacentHTML('beforeend', `
          <button class="btn primary quiz-next" style="margin-top:12px;width:100%">Volgende vraag</button>
        `)
        feedback.querySelector('.quiz-next').addEventListener('click', renderQuiz)
      })
    })
  }

  // --- Tab switching ---
  const tabList = root.querySelector('#tab-list')
  const tabQuiz = root.querySelector('#tab-quiz')
  const listView = root.querySelector('#phrase-list-view')
  const quizView = root.querySelector('#phrase-quiz-view')

  tabList.addEventListener('click', () => {
    quizMode = false
    tabList.classList.add('active')
    tabQuiz.classList.remove('active')
    listView.hidden = false
    quizView.hidden = true
  })

  tabQuiz.addEventListener('click', () => {
    quizMode = true
    tabQuiz.classList.add('active')
    tabList.classList.remove('active')
    quizView.hidden = false
    listView.hidden = true
    if (!quizView.innerHTML) renderQuiz()
    else renderQuiz()
  })
}
